export const SET_LOADING = 'SET_LOADING';
export const GET_INDICATORS = 'GET_INDICATORS';
export const SET_INDICATOR = 'SET_INDICATOR';
export const SET_LOADING_ERROR = 'SET_LOADING_ERROR';
export const GET_INDICATORS_ERROR = 'GET_INDICATORS_ERROR';
export const SET_INDICATOR_ERROR = 'SET_INDICATOR_ERROR';
export const DELETE_INDICATOR = 'DELETE_INDICATOR';
export const DELETE_INDICATOR_ERROR = 'DELETE_INDICATOR_ERROR';
export const CLEAR_INDICATORS = 'CLEAR_INDICATORS';

export const GET_FILTERS = 'GET_FILTERS';
export const SET_FILTER = 'SET_FILTER';
export const DELETE_FILTER = 'DELETE_FILTER';
export const GET_FILTERS_ERROR = 'GET_FILTERS_ERROR';
export const SET_FILTER_ERROR = 'SET_FILTER_ERROR';

export const GET_DATA = "GET_DATA";
export const GET_DATA_ERROR = 'GET_DATA_ERROR';
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA_ERROR = 'GET_USER_DATA_ERROR';
export const CLEAR_DATA = "CLEAR_DATA";
export const CLEAR_DATA_ERROR = "CLEAR_DATA_ERROR";

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH = 'REFRESH';
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const POST_MESSAGE = 'POST_MESSAGE';
export const WAIT_FOR_TOKEN = 'WAIT_FOR_TOKEN';

export const CHECK_STATUS = "CHECK_STATUS";

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const REFRESH_ERROR = 'REFRESH_ERROR';
export const VALIDATE_TOKEN_ERROR = 'VALIDATE_TOKEN_ERROR';
export const POST_MESSAGE_ERROR = 'POST_MESSAGE_ERROR';


export const HIDE_DATA = 'HIDE_DATA';
export const SHOW_DATA = 'SHOW_DATA';


export const GET_REPORTS = 'GET_REPORTS';
export const GET_REPORTS_ERROR = 'GET_REPORTS_ERROR';

export const POST_REPORT = 'POST_REPORT';
export const POST_REPORT_ERROR = 'POST_REPORT_ERROR';


export const GET_LABELS = 'GET_LABELS';
export const GET_LABELS_ERROR = 'GET_LABELS_ERROR';

export const GET_VALUES= 'GET_VALUES';
export const GET_VALUES_ERROR = 'GET_VALUES_ERROR';


export const UPDATE_VALUES ='UPDATE_VALUES';
export const UPDATE_VALUES_ERROR='UPDATE_VALUES_ERROR';

export const UPLOAD_XML ='UPLOAD_XML';
export const UPLOAD_XML_ERROR='UPLOAD_XML_ERROR';


export const GET_HOSPITAL ='GET_HOSPITAL';
export const GET_HOSPITAL_ERROR='GET_HOSPITAL_ERROR';

export const UPDATE_HOSPITAL ='UPDATE_HOSPITAL';
export const UPDATE_HOSPITAL_ERROR='UPDATE_HOSPITAL_ERROR';


export const DELETE_REPORT= 'DELETE_REPORT';
export const DELETE_REPORT_ERROR = 'DELETE_REPORT_ERROR';

export const SET_ACTIVE_PLOT= 'SET_ACTIVE_PLOT';
export const SET_ACTIVE_PLOT_ERROR = 'SET_ACTIVE_PLOT_ERROR';

export const SET_PREVIOUS_FILTER= 'SET_PREVIOUS_FILTER';
export const SET_PREVIOUS_FILTER_ERROR = 'SET_PREVIOUS_FILTER_ERROR';

export const DELETE_PREVIOUS_FILTER= 'DELETE_PREVIOUS_FILTER';
export const DELETE_PREVIOUS_FILTER_ERROR = 'DELETE_PREVIOUS_FILTER_ERROR';


export const SET_PREVIOUS_DATA= 'SET_PREVIOUS_DATA';
export const SET_PREVIOUS_DATA_ERROR = 'SET_PREVIOUS_DATA_ERROR';

export const DELETE_PREVIOUS_DATA= 'DELETE_PREVIOUS_DATA';
export const DELETE_PREVIOUS_DATA_ERROR = 'DELETE_PREVIOUS_DATA_ERROR';


export const SET_STATISTICS_ERROR = 'SET_STATISTICS_ERROR';
export const SET_STATISTICS= 'SET_STATISTICS';

export const DELETE_STATISTIC = 'DELETE_STATISTIC';
export const DELETE_STATISTIC_ERROR = 'DELETE_STATISTIC_ERROR';


export const CLEAR_PREVIOUS_FILTER = 'CLEAR_PREVIOUS_FILTER';
export const CLEAR_PREVIOUS_FILTER_ERROR = 'CLEAR_PREVIOUS_FILTER_ERROR';


export const REMOVE_PLOT_POINT = 'REMOVE_PLOT_POINT';

export const HIDE_ALL_POINTS = 'HIDE_ALL_POINTS';
export const SHOW_ALL_POINTS = 'SHOW_ALL_POINTS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const REFRESH_FILTERS = 'REFRESH_FILTERS';

export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';

export const CLEAR_BASIC_FILTER =  'CLEAR_BASIC_FILTER';


export const GET_OPKS = 'GET_OPKS';
export const GET_OPKS_ERROR = 'GET_OPKS_ERROR';

export const GET_PROCEDURE_FOR_PRICING = 'GET_PROCEDURE_FOR_PRICING';
export const GET_PROCEDURE_FOR_PRICING_ERROR = 'GET_PROCEDURE_FOR_PRICING_ERROR';

export const GET_PROCEDURE_STAFF_CALUCATION = 'GET_PROCEDURE_STAFF_CALUCATION';
export const GET_PROCEDURE_STAFF_CALUCATION_ERROR = 'GET_PROCEDURE_STAFF_CALUCATION_ERROR';


export const GET_PROCEDURE_MATERIAL_CALUCATION = 'GET_PROCEDURE_MATERIAL_CALUCATION';
export const GET_PROCEDURE_MATERIAL_CALUCATION_ERROR = 'GET_PROCEDURE_MATERIAL_CALUCATION_ERROR';

export const CLEAR_PROCEDURE_MATERIAL_CALUCATION = 'CLEAR_PROCEDURE_MATERIAL_CALUCATION';
export const CLEAR_PROCEDURE_STAFF_CALUCATION = 'CLEAR_PROCEDURE_STAFF_CALUCATION';

export const EDIT_PROCEDURE_MATERIAL_CALUCATION = 'EDIT_PROCEDURE_MATERIAL_CALUCATION';
export const EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR = 'EDIT_PROCEDURE_MATERIAL_CALUCATION_ERROR';

export const POST_PROCEDURE_MATERIAL_CALUCATION = 'POST_PROCEDURE_MATERIAL_CALUCATION';
export const POST_PROCEDURE_MATERIAL_CALUCATION_ERROR = 'POST_PROCEDURE_MATERIAL_CALUCATION_ERROR';


export const GET_AVAILABLE_MATERIALS = 'GET_AVAILABLE_MATERIALS';
export const GET_AVAILABLE_MATERIALS_ERROR = 'GET_AVAILABLE_MATERIALS_ERROR';

export const GET_AVAILABLE_STAFF = 'GET_AVAILABLE_STAFF';
export const GET_AVAILABLE_STAFF_ERROR = 'GET_AVAILABLE_STAFF_ERROR';


export const EDIT_PROCEDURE_STAFF_CALUCATION = 'EDIT_PROCEDURE_STAFF_CALUCATION';
export const EDIT_PROCEDURE_STAFF_CALUCATION_ERROR = 'EDIT_PROCEDURE_STAFF_CALUCATION_ERROR';

export const POST_PROCEDURE_STAFF_CALUCATION = 'POST_PROCEDURE_STAFF_CALUCATION';
export const POST_PROCEDURE_STAFF_CALUCATION_ERROR = 'POST_PROCEDURE_STAFF_CALUCATION_ERROR';


export const GET_PROCEDURES_SUMMARY = 'GET_PROCEDURES_SUMMARY';
export const GET_PROCEDURES_SUMMARY_ERROR = 'GET_PROCEDURES_SUMMARY_ERROR';

export const GET_STAFF_ARCHIVE = 'GET_STAFF_ARCHIVE';
export const GET_STAFF_ARCHIVE_ERROR = 'GET_STAFF_ARCHIVE_ERROR';


export const GET_MATERIAL_ARCHIVE = 'GET_MATERIAL_ARCHIVE';
export const GET_MATERIAL_ARCHIVE_ERROR = 'GET_MATERIAL_ARCHIVE_ERROR';

export const GET_PROCEDURE_ARCHIVE = 'GET_PROCEDURE_ARCHIVE';
export const GET_PROCEDURE_ARCHIVE_ERROR = 'GET_PROCEDURE_ARCHIVE_ERROR';

export const EDIT_ARCHIVE_FAIL = 'EDIT_ARCHIVE_FAIL';
export const EDIT_ARCHIVE_LOADING = 'EDIT_ARCHIVE_LOADING';
export const EDIT_ARCHIVE_MATERIAL = 'EDIT_ARCHIVE_MATERIAL';
export const EDIT_ARCHIVE_PERSONEL = 'EDIT_ARCHIVE_PERSONEL';

export const REMOVE_USER_PLOT_POINT="REMOVE_USER_PLOT_POINT"


export const GET_FILES_TO_CALCULATE = 'GET_FILES_TO_CALCULATE';
export const GET_FILES_TO_CALCULATE_ERROR = 'GET_FILES_TO_CALCULATE_ERROR';
export const MODIFY_SINGLE_FILE = 'MODIFY_SINGLE_FILE';


export const POST_FILES_TO_CALCULATE = 'POST_FILES_TO_CALCULATE';
export const POST_FILES_TO_CALCULATE_ERROR = 'POST_FILES_TO_CALCULATE_ERROR';


export const GET_EXCEL_TEMPLATE = 'GET_EXCEL_TEMPLATE';
export const POST_OPK = 'POST_OPK';

export const POST_FOUR = 'POST_FOUR';

export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS';

export const EDIT_COMPANY_FAIL = 'EDIT_COMPANY_FAIL';



export const GET_UNIT_TYPE = 'GET_UNIT_TYPE';
export const GET_UNIT_TYPE_ERROR = 'GET_UNIT_TYPE_ERROR';


export const GET_MATERIAL_TYPE = 'GET_MATERIAL_TYPE';
export const GET_MATERIAL_TYPE_ERROR = 'GET_MATERIAL_TYPE_ERROR';



export const POST_UNIT_TYPE = 'POST_UNIT_TYPE';
export const POST_UNIT_TYPE_ERROR = 'POST_UNIT_TYPE_ERROR';


export const POST_MATERIAL_TYPE = 'POST_MATERIAL_TYPE';
export const POST_MATERIAL_TYPE_ERROR = 'POST_MATERIAL_TYPE_ERROR';

export const TYPE_LOADING = 'TYPE_LOADING';

export const POST_AVAILABLE_PERSONEL = 'POST_AVAILABLE_PERSONEL';
export const POST_AVAILABLE_PERSONEL_ERROR = 'POST_AVAILABLE_PERSONEL_ERROR';




export const SET_EDIT_LOADING = 'SET_EDIT_LOADING';
export const CLEAR_EDIT_ERRORS = 'CLEAR_EDIT_ERRORS';


export const CLEAR_BASIC_ERRORS = 'CLEAR_BASIC_ERRORS';


export const DELETE_PROCEDURE_STAFF_CALUCATION = 'DELETE_PROCEDURE_STAFF_CALUCATION';
export const DELETE_PROCEDURE_STAFF_CALUCATION_ERROR = 'DELETE_PROCEDURE_STAFF_CALUCATION_ERROR';

export const DELETE_PROCEDURE_MATERIAL_CALUCATION = 'DELETE_PROCEDURE_MATERIAL_CALUCATION';
export const DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR = 'DELETE_PROCEDURE_MATERIAL_CALUCATION_ERROR';

export const GET_OPK_FILTERS = 'GET_OPK_FILTERS';
export const GET_OPK_FILTERS_ERROR = 'GET_OPK_FILTERS_ERROR';

export const GET_YEARLY_DATA = 'GET_YEARLY_DATA';
export const GET_YEARLY_DATA_ERROR = 'GET_YEARLY_DATA_ERROR';


export const DELETE_ALL_PREVIOUS_SUBFILTERS= 'DELETE_ALL_PREVIOUS_SUBFILTERS';
export const DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR = 'DELETE_ALL_PREVIOUS_SUBFILTERS_ERROR';


export const DELETE_IMPORTED_FOURTH_FIFTH_FILE = 'DELETE_IMPORTED_FOURTH_FIFTH_FILE';
export const ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE = 'ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE'